<template>
  <el-dialog
    :visible="showDialog"
    width="85%"
    append-to-body
    class="chartDia"
    @close="close"
  >
    <div slot="title" class="slotTit">项目支付详情</div>
    <el-tabs v-model="activeTask2" type="card">
      <el-tab-pane label="项目支付金额" name="projectPay">
        <project-pay></project-pay>
        <el-button @click="close" type="primary" class="confirmBtn">
          确认
        </el-button>
      </el-tab-pane>
      <el-tab-pane label="终端结算金额" name="terminalPay">
        <p style="color:red;text-align:left;">
          由于计算方式，此处明细为四舍五入计算，与总价可能会有差距，实际金额以电子回单为主
        </p>
        <terminal-pay></terminal-pay>
        <el-button @click="close" type="primary" class="confirmBtn">
          确认
        </el-button>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>
<script>
import projectPay from './projectPay.vue';
import terminalPay from './terminalPay.vue';
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    activeTask: {
      type: String,
      default: 'projectPay'
    }
  },
  data() {
    return {
      activeTask2: this.activeTask
    };
  },
  components: {
    projectPay,
    terminalPay
  },
  methods: {
    close() {
      this.$parent.$parent.componentName = '';
    }
  }
};
</script>
<style lang="scss" scoped>
.confirmBtn {
  display: block;
  margin: auto;
}
</style>
